import styles from './styles.module.scss';
import {GrMenu} from "react-icons/gr";

const ContextButton = ({onClick}) => {
	return (
		<GrMenu className={styles.contextButton} onClick={onClick} />						
	)
}

export default ContextButton;